const pendingRequests = new Map();

export const singleFlight = (key, request) => {
  const pending = pendingRequests.get(key);
  if (pending) return pending;

  const promise = Promise.resolve(request());
  pendingRequests.set(key, promise);
  const clear = () => pendingRequests.delete(key);
  promise.then(clear, clear);
  return promise;
};
